<nested-node-select-insight
    [nodes]="localState?.nodes"
    [selection]="localState?.selection"
    [standAloneParent]="true"
    [canSelect]="_canSelect"
    (change)="_onChange($event)"
>
</nested-node-select-insight>
